import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-matrix-request-history',
  templateUrl: './matrix-request-history.component.html',
  styleUrls: ['./matrix-request-history.component.scss']
})
export class MatrixRequestHistoryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
